import React, { useRef } from 'react';
import { useReveal } from '../Components/Fx/useReveal';

const SupportPage = () => {
   const scope = useRef<HTMLDivElement>(null);
   useReveal(scope);

   return (
      <div ref={scope} className="page grid grid-cols-1 gap-10 md:grid-cols-12">
         <div className="space-y-6 text-lg leading-relaxed text-bone-muted md:col-span-8 lg:col-span-6">
            <p className="font-display text-3xl leading-snug text-bone md:text-4xl" data-reveal>
               You're probably here because you know we could use a hand to keep this website going strong.
            </p>
            <p data-reveal>
               If you've been enjoying our content and find it helpful, please consider donating. Your contributions go
               straight into two buckets: one to keep the servers humming along so you can access the archive without a
               hitch, and the other to improve your overall experience on the site.
            </p>
            <p data-reveal>
               Every little bit counts, and your support means the world to us. If you've got a few bucks to spare, help
               us keep the digital lights on. Thanks a million for being part of this.
            </p>
         </div>

         <div className="md:col-span-4 md:col-start-9" data-reveal>
            <div className="card md:sticky md:top-24">
               <p className="eyebrow mb-4">Fund the archive</p>
               <p className="mb-8 font-display text-3xl text-bone">Every record kept costs something.</p>
               <a
                  href="https://www.buymeacoffee.com/redsentinel"
                  rel="noreferrer"
                  target="_blank"
                  className="button w-full"
               >
                  Donate ↗
               </a>
            </div>
         </div>
      </div>
   );
};

export default SupportPage;
